const storagePrefix = "sidebar-menu:";

const storedState = (key) => {
    try {
        const value = window.localStorage.getItem(`${storagePrefix}${key}`);

        return value === null ? null : value === "true";
    } catch {
        return null;
    }
};

const storeState = (key, open) => {
    try {
        window.localStorage.setItem(`${storagePrefix}${key}`, String(open));
    } catch {}
};

export const registerSidebarMenu = (Alpine) => {
    Alpine.data("sidebarMenu", ({ key, active = false }) => ({
        open: active || storedState(key) === true,
        toggle() {
            this.open = !this.open;
            storeState(key, this.open);
        },
    }));
};
